<template>
  <div>
    <push-permission-sheet
      :visible="sheets.permission.visible"
      :trigger="sheets.permission.trigger"
      :denied="sheets.permission.denied"
      @accept="resolvePushPermission('accept')"
      @decline="resolvePushPermission('decline')"
      @dismiss="resolvePushPermission(null)"
    />
  </div>
</template>

<script>
import PushPermissionSheet from '@/components/push/PushPermissionSheet';
import { onEnteredAuthArea } from '@/services/push/pushPrompt';
import { pushSheets, resolvePushPermission } from '@/services/push/pushSheets';

// Host das superfícies do push. Montado UMA vez em layout/Index.vue, ao lado do
// <DownloadSheets />: o estado vem do observable services/push/pushSheets.
export default {
  name: 'PushSheets',
  components: { PushPermissionSheet },
  data () {
    return { sheets: pushSheets };
  },
  watch: {
    // Pedido na 1ª entrada na área logada (sc-6255): depois do login ou na 1ª
    // abertura de quem já estava logado. `immediate` cobre o boot já na área logada.
    $route: {
      immediate: true,
      handler (to) {
        if (to && to.matched.some(route => route.meta && route.meta.isAuth)) onEnteredAuthArea();
      }
    }
  },
  methods: {
    resolvePushPermission
  }
};
</script>
